import colors from './colors'
import fonts from './fonts'

export default {
    default: {},
    tourPanel: {
        container: {
            width: '100%',
            padding: '27px 52px',
        },
        backgroundText: {
            position: 'absolute',
            left: '0',
            top: '0',
            color: colors.white,
            opacity: '.12',
            width: '200%',
            lineHeight: 1,
            fontSize: '7em',
            fontWeigth: 'bold',
            whiteSpace: 'nowrap',
        },
        foregroundText: {
            color: colors.white,
            fontSize: '1.6em',
        },
    },
}
